import React, { Component } from 'react';
import RestaurantListItem from './RestaurantListItem'
import restaurants from '../data/restaurants'
import './RestaurantList.css'

class RestaurantList extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {

  }
  render() {
    return (
      <section id="RestaurantList">
        {restaurants.map((restaurant, i) => {
          return <RestaurantListItem restaurant={restaurant} key={restaurant.id} />
        })}
      </section>
    )
  }
}

export default RestaurantList



// WEBPACK FOOTER //
// ./src/components/RestaurantList.js